import React, { useContext } from "react"
import { Link } from "gatsby"
import {
  solidButton,
  small, normal, large,
  disabled as isDisabled,
  success, warn,
  textButton,
  noChildren,
  outlinedButton,
  underlinedButton,
  quantityButton,
  hasActionButton,
} from "src/components/core/atoms/button/button.module.css"
import { Plus, Minus } from "react-feather"
import { CartContext } from "src/context/CartContext"
import classnames from "classnames/bind"

const cx = classnames.bind( {
  solidButton,
  small, normal, large,
  isDisabled,
  success, warn,
  textButton,
  noChildren,
  outlinedButton,
  underlinedButton,
  quantityButton,
  hasActionButton,
} )

export const SolidButton = ( {
  onClick = () => { },
  leftIcon = "",
  rightIcon = "",
  type = "",
  disabled,
  children,
  size,
} ) => {
  return (
    <button
      type={ type }
      className={ cx( "solidButton", size, { 'isDisabled': disabled } ) }
      onClick={ !disabled ? onClick : () => { } }
    >
      {leftIcon }
      {children }
      {rightIcon }
    </button>
  )
}

export const TextButton = ( {
  onClick,
  leftIcon = "",
  rightIcon = "",
  type = "",
  size,
  children,
} ) => {
  return (
    <button
      type={ type }
      className={ cx( "textButton", size, { 'noChildren': [ !children ] } ) }
      onClick={ onClick }
    >
      {leftIcon }
      {children }
      {rightIcon }
    </button>
  )
}

export const LinkButton = ( {
  to = "/404",
  leftIcon = "",
  rightIcon = "",
  children,
  onClick,
} ) => {
  return (
    <Link className={ cx( "textButton" ) } to={ to } onClick={ onClick }>
      {leftIcon }
      {children }
      {rightIcon }
    </Link>
  )
}

export const OutlinedButton = ( {
  onClick,
  leftIcon = "",
  rightIcon = "",
  type = "",
  children,
} ) => {
  return (
    <button type={ type } className={ cx( "outlinedButton" ) } onClick={ onClick }>
      {leftIcon }
      {children }
      {rightIcon }
    </button>
  )
}

export const UnderlinedButton = ( {
  onClick = () => { },
  leftIcon = "",
  rightIcon = "",
  type = "",
  children,
} ) => {
  return (
    <button type={ type } className={ cx( "underlinedButton" ) } onClick={ onClick }>
      {leftIcon }
      <u>{ children }</u>
      {rightIcon }
    </button>
  )
}

export const QuantityButton = ( {
  action,
  actionText = "Add",
  color = "success",
  item,
  reloader,
} ) => {
  const { dispatchCart, ACTIONS, count } = useContext( CartContext )

  return (
    <div className={ cx( 'quantityButton', { 'hasActionButton': action } ) }>
      <Minus onClick={ () => {
        dispatchCart( { type: ACTIONS.CART_ITEM_DECREASE_QNT, payload: { item, hasAction: typeof action !== "undefined" } } )
        reloader()
      } } />
      <span>{ count ? ( count[ item.product_id ] || 0 ) : 0 }</span>
      <Plus onClick={ () => {
        dispatchCart( { type: ACTIONS.CART_ITEM_INCREASE_QNT, payload: { item, hasAction: typeof action !== "undefined" } } )
        reloader()
      } } />
      {action && (
        <button className={ cx( color ) } onClick={ action }>
          { actionText }
        </button>
      ) }
    </div>
  )
}

export default SolidButton
